import React from 'react'
import { updateAdditionalInfo } from 'client/utils/api-routes-orders'
import { OrdersContext } from 'contexts/OrdersContext'
import {
  DcButton,
  DcDropDown,
  DcFlexBox,
  DcText,
  PixelDate,
  PixelFactoryContext,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'

import { IPixelFactory, OrderDetail } from '../../../../../../decl.d'

interface IProps {
  details: OrderDetail
  detailID: number
  handleClose: () => void
  setDetails: (details: OrderDetail) => void
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
}
const EditStoreAdditionalInfo = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { state } = React.useContext(OrdersContext)
  const {
    details,
    handleClose,
    detailID,
    setDetails,
    newOrder,
    newOrderData,
    setNewOrderData,
  } = props
  const [orderSource, setOrderSource] = React.useState<any>([])
  const [saleby, setSaleBy] = React.useState<any>([])
  const [meta, setMeta] = React.useState<any>({
    added_by: '',
    business_name: '',
    last_modified: '',
    modified_by: '',
    order_source: '',
    sale_by: '',
    sale_by_id: '',
  })
  const [newOrderMeta, setNewOrderMeta] = React.useState<any>({
    added_by: '',
    // business_id: '',
    // business_name: '',
    last_modified: '',
    modified_by: '',
    order_source: '',
    sale_by: '',
    sale_by_id: '',
  })

  React.useEffect(() => {
    if (!newOrder) {
      setMeta(details?.meta)
    }
  }, [details])

  const handleUpdateMeta = () => {
    showPageLoader()
    updateAdditionalInfo(detailID, meta).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Meta Information Updated')
        setDetails(res.response.data)
      }
    })
  }

  const onSaleByChange = (e) => {
    if (newOrder) {
      setNewOrderMeta({
        ...newOrderMeta,
        sale_by_id: e.target.value,
        sale_by: e.target.options[e.target.selectedIndex].text,
      })
      setNewOrderData({
        ...newOrderData,
        meta: {
          ...newOrderMeta,
          sale_by_id: e.target.value,
          sale_by: e.target.options[e.target.selectedIndex].text,
        },
      })
    } else {
      setMeta({
        ...meta,
        sale_by_id: e.target.value,
        sale_by: e.target.options[e.target.selectedIndex].text,
      })
    }
  }

  React.useEffect(() => {
    setOrderSource(state?.orderSources)
    setSaleBy(state?.salePersons)
    setNewOrderMeta({
      ...newOrderMeta,
      order_source: state?.orderSources?.find(
        (item) => item.is_default === true,
      )?.code,
      sale_by_id: state?.salePersons?.find((item) => item.me === true)?.id,
    })
  }, [state])

  React.useEffect(() => {
    setNewOrderData({
      ...newOrderData,
      meta: newOrderMeta,
    })
  }, [newOrderMeta])

  return (
    <SectionContent>
      <FormContainer gap={newOrder}>
        {!newOrder && (
          <DcFlexBox width="100%">
            <DcFlexBox gap="10px">
              <DcText style={{ fontWeight: '600' }} fontWeight="600">
                Created At :
              </DcText>
              <DcText>
                <PixelDate
                  className="textSmall"
                  value={meta?.date_created}
                  format={'dateWithTime'}
                />
              </DcText>
            </DcFlexBox>
            <DcFlexBox gap="10px">
              <DcText style={{ fontWeight: '600' }}>Created By:</DcText>{' '}
              <DcText>{meta?.added_by}</DcText>
            </DcFlexBox>
          </DcFlexBox>
        )}

        <FormGroup direction={newOrder} gap={newOrder}>
          <FilterInput padding={newOrder}>
            <DcDropDown
              placeholder="Select Order Source"
              options={[
                {
                  description: 'Select Order Source',
                  code: '',
                },
                ...orderSource,
              ].map((data) => {
                return { label: data.description, value: data.code }
              })}
              value={newOrder ? newOrderMeta.order_source : meta.order_source}
              onChange={(e) => {
                if (newOrder) {
                  setNewOrderMeta({
                    ...newOrderMeta,
                    order_source: e.target.value,
                  })
                  setNewOrderData({
                    ...newOrderData,
                    meta: {
                      ...newOrderMeta,
                      order_source: e.target.value,
                    },
                  })
                } else {
                  setMeta({ ...meta, order_source: e.target.value })
                }
              }}
            />
          </FilterInput>

          <FilterInput padding={newOrder}>
            <DcDropDown
              placeholder="Select Sale By"
              options={[
                {
                  name: 'Select Sale By',
                  id: '',
                },
                ...saleby,
              ]?.map((data) => {
                return { label: data.name, value: data.id }
              })}
              value={newOrder ? newOrderMeta.sale_by_id : meta.sale_by_id}
              onChange={(e) => {
                onSaleByChange(e)
              }}
            />
          </FilterInput>
        </FormGroup>
        {!newOrder && (
          <FormGroup flexEnd>
            <DcButton
              variant="outline-secondary"
              onClick={() => {
                handleClose()
              }}
            >
              Close
            </DcButton>
            <DcButton
              onClick={() => {
                handleUpdateMeta()
              }}
            >
              Update
            </DcButton>
          </FormGroup>
        )}
      </FormContainer>
    </SectionContent>
  )
}

const FormContainer = styled.div<{ gap?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${(props) => (props.gap ? '0' : '10px')};
`

const FormGroup = styled.div<{
  flexEnd?: boolean
  direction?: boolean
  gap?: boolean
}>`
  display: inline-flex;
  flex-direction: ${(props) => (props.direction ? 'column' : 'row')};
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: ${(props) => (props.gap ? '0px' : '10px')};
  .full-width {
    flex-grow: 1;
  }
`

const FilterInput = styled.div<{ padding?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
  padding: ${(props) => (props.padding ? '10px' : '0px')};
`

export default EditStoreAdditionalInfo
